import { buildElasticGraphQLParams, getMemberType } from './converterSelector';
import { updateLivestockFilter } from '../actions/productActions';

export const getProductFullInfo = (list) => {
    return Object.values(list);
};
export const getSelectedFilters = (state) => {
    return state.listParams.filters;
};
export const getSelectedSortBy = (state) => {
    const { sortBy, sortDirection } = state.listParams;

    return {
        sortBy: sortBy,
        sortDirection: sortDirection,
    };
};

export const getSelectedListStyle = (state) => {
    return state.viewType || 'grid';
};

export const getShowNLISFilter = (state) => {
    const { showNLISFilter, localeCountry, orderOnBehalf} = window;

    return (showNLISFilter && localeCountry === 'Australia' && (getMemberType(state) !== 'wholesaler' || orderOnBehalf !== false));
};

export const getShowNAITFilter = (state) => {
    const { showNAITFilter, localeCountry, orderOnBehalf} = window;

    return (showNAITFilter && localeCountry === 'New Zealand' && (getMemberType(state) !== 'wholesaler' || orderOnBehalf !== false));
};

export const buildRequestProductsParams = (listParams) => {
    let newlistParams = JSON.parse(JSON.stringify(listParams));

    if (
        typeof newlistParams.filters != 'undefined' &&
        typeof newlistParams.filters.LiveStockType != 'undefined'
    ) {
        Object.entries(newlistParams.filters.LiveStockType).map(
            ([key, value]) => {
                if (typeof value == 'boolean' && value === false) {
                    delete newlistParams.filters.LiveStockType[key];
                }
            }
        );
    }

    return buildElasticGraphQLParams(newlistParams);
};
export const getDefaultFilters = () => {
    const isSearchPage = typeof window.q != 'undefined' || false;
    let filters = {};

    if (!isSearchPage) {
        filters.IsFeatured = true;
    }

    // LiveStockType Filter
    if (
        typeof window.defaultSelectedFilters != 'undefined' &&
        window.defaultSelectedFilters &&
        Array.isArray(window.defaultSelectedFilters)
    ) {
        const selectedFilters = window.defaultSelectedFilters;

        if (selectedFilters.length > 0) {
            selectedFilters.map((selectedFilter) => {
                let filter = '';

                switch (selectedFilter.toLowerCase()) {
                    case 'cattle':
                        filter = 'Cattle';
                        break;
                    case 'sheep':
                        filter = 'Sheep';
                        break;
                    case 'pig':
                        filter = 'Pig';
                        break;
                    case 'deer':
                        filter = 'Deer';
                        break;
                    case 'goat':
                        filter = 'Goat';
                        break;
                    case 'nlis':
                        filter = 'NLIS';
                        break;
                    case 'nait':
                        filter = 'NAIT';
                        break;
                }

                if (typeof filters.LiveStockType == 'undefined') {
                    filters.LiveStockType = {};
                }

                if (filter) {
                    filters.LiveStockType[filter] = true;
                }
            });
        }
    }

    return filters;
};
export const getAvailableSortBy = () => {
    let availableSortBy = [];
    const isSearchPage = typeof window.q != 'undefined' || false;

    // Relevance
    availableSortBy.push({
        localizedText: isSearchPage ? 'SORT.RELEVANCE' : 'SORT.DEFAULT',
        icon: 'icon-sort-name-up',
        sortBy: '',
        sortDirection: '',
    });

    // Product Name
    availableSortBy = [
        ...availableSortBy,
        {
            localizedText: 'SORT.PRODUCT_NAME_ASC',
            icon: 'icon-sort-name-up',
            sortBy: 'URLSegment',
            sortDirection: 'ASC',
        },
        {
            localizedText: 'SORT.PRODUCT_NAME_DESC',
            icon: 'icon-sort-name-down',
            sortBy: 'URLSegment',
            sortDirection: 'DESC',
        },
    ];

    // Price
    // if(!isSearchPage) {
    //     availableSortBy = [...availableSortBy,
    //         {
    //             localizedText: 'SORT.PRICE_ASC',
    //             icon: 'icon-sort-price-up',
    //             sortBy: 'Price',
    //             sortDirection: 'ASC',
    //         },
    //         {
    //             localizedText: 'SORT.PRICE_DESC',
    //             icon: 'icon-sort-price-down',
    //             sortBy: 'Price',
    //             sortDirection: 'DESC',
    //         }
    //     ];
    // }

    return availableSortBy;
};
